import Home from '../DashBoard/Home'

const routes = [
    {
        id: 1,
        path: "/home",
        name: "Home",
        element: <Home/>
    }
]

export default routes;